import { createContext } from 'react';

type Props = {
	interval: number;
	intervalUnit: string;
	dateFormat: string;
	currentDate: string;
};

const ScheduleConfigurationContext = createContext<Props>({
	interval: 2,
	intervalUnit: 'weeks',
	dateFormat: 'dd D/MM',
	currentDate: new Date().toISOString(),
});

export const ScheduleConfigurationProvider = ScheduleConfigurationContext.Provider;
export const ScheduleConfigurationConsumer = ScheduleConfigurationContext.Consumer;
